import React, { uselocalState, useRef, useEffect, useState } from 'react';
import TablaContactos from './Components/TablaContactos';
import { Button } from 'primereact/button';
import ModalEditar from './Components/ModalEditar';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useGlobalContext } from "../shared/context/global.context"; 
import { GetComercioContactos, consultarTipoContactoComercio } from './services/comercio.service';
import '../../pages/shared/components/button/buttonDemo.scss';


const CambiarDatosContacto = () => {
    const {comercioSelecionado} = useGlobalContext()

    const [localState , setLocalState]=useState({
        modal:false,
        modifyModal:false,
        modify:{},
        tipoContactos:[],
        contactos:[]
    })

    const handleClick = (rowData) => {
        setLocalState({...localState,modify:rowData,modifyModal:!localState.modifyModal})
    };

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const  {data,status} = await GetComercioContactos(comercioSelecionado[0].comercioId)
                const result2 = await consultarTipoContactoComercio()
                setLocalState({...localState,contactos:data.contactos,tipoContactos:result2.data.tipoContactoComercioDTOs})
            } catch (error) {
              console.log(error);
            }
          }
          ;
          fetchDetails()
          ;
        }, []);


    const fetchGetComercio =async()=>{
        const  {data,status}  = await GetComercioContactos(comercioSelecionado[0].comercioId)
        setLocalState({...localState,contactos:data.contactos})
            
    }
    const   fetchTipoContactos=async()=>{
        const result = await consultarTipoContactoComercio()
        setLocalState({...localState,tipoContactos:result.data.tipoContactoComercioDTOs})
     }

    return (
        
          <div style={{paddingTop:'0.5rem'}}> 
             <Accordion activeIndex={0}>
                <AccordionTab header="Gestion de Contactos ">
                    <div className="justify-content-end" style={{paddingTop:'0.5rem'}}>
                         <div className="button-demo">
                            <div className="template">
                                <Button className="twitter p-0"aria-label="Twitter" onClick={() => setLocalState({...localState,modal:!localState.modal})} >
                                    <i className="pi pi-plus px-2"></i>
                                    <span className="px-3">Agregar</span>
                                </Button>
                            </div>
                        </div>
                        </div>
                {localState.modal && <ModalEditar tipoContactos={localState.tipoContactos} reloadContacts={fetchGetComercio}/>}
                 {localState.modifyModal ? <ModalEditar tipoContactos={localState.tipoContactos} reloadContacts={fetchGetComercio} selectedUser={localState.modify} type='modify'   /> : <div></div>} 
                <TablaContactos handleModify={handleClick} reloadContacts={fetchGetComercio} contactos={localState.contactos} tipoContactos={localState.tipoContactos}></TablaContactos>
            </AccordionTab>
        </Accordion>
        </div >  
        
         
    );
};

export default CambiarDatosContacto;